import React from 'react';
import { Quill } from 'react-quill';
import fetch from 'cross-fetch';
import { v4 as uuidv4 } from 'uuid';

// TODO: use portal api and remove osiris api
import { generatePresignedPutUrl } from '../../../api/osiris-api';

// Custom Undo button icon component for Quill editor. You can import it directly
// from 'quill/assets/icons/undo.svg' but I found that a number of loaders do not
// handle them correctly
const CustomUndo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
    <path
      className="ql-stroke"
      d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
    />
  </svg>
);

// Redo button icon component for Quill editor
const CustomRedo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
    <path
      className="ql-stroke"
      d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
    />
  </svg>
);

// Undo and redo functions for Custom Toolbar
function undo() {
  this.quill.history.undo();
}

function redo() {
  this.quill.history.redo();
}

// Add sizes to whitelist and register them
const Size = Quill.import('formats/size');
Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
Quill.register(Size, true);

// Add fonts to whitelist and register them
const Font = Quill.import('formats/font');
Font.whitelist = [
  'arial',
  'comic-sans',
  'courier-new',
  'georgia',
  'helvetica',
  'lucida'
];

Quill.register(Font, true);

async function imageHandler() {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files[0];
    const uuid = uuidv4();
    const fileName = `${uuid}-${file.name}`;
    const s3UrlGenerator = await generatePresignedPutUrl({ s3Key: fileName });
    const s3PutUrl = s3UrlGenerator.data[0];

    const range = this.quill.getSelection(true);

    try {
      const response = await fetch(s3PutUrl, {
        method: 'PUT',
        body: file
      });

      const s3GetUrl = response.url.split('?')[0];

      this.quill.insertEmbed(range.index, 'image', s3GetUrl);
    } catch (error) {
      console.log(error);
      alert('Something went wrong with uploading your logo.');
    }
  };
}

// Modules object for setting up the Quill editor
export const getModules = id => ({
  toolbar: {
    container: `#${id}`,
    handlers: {
      undo,
      redo,
      image: imageHandler
    }
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  }
});

// Formats objects for setting up the Quill editor
export const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'align',
  'strike',
  'list',
  'bullet',
  'indent',
  'link',
  'image'
];

// Quill Toolbar component
export const QuillToolbar = ({ id }) => (
  <div id={id}>
    <span className="ql-formats">
      <select className="ql-header" defaultValue="3">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="3">Normal</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-indent" value="-1" />
      <button className="ql-indent" value="+1" />
    </span>
    <span className="ql-formats">
      <select className="ql-align" />
    </span>
    <span className="ql-formats">
      <button className="ql-link" />
      <button className="ql-image" />
    </span>
  </div>
);

export default QuillToolbar;
